import { useEffect, useState, useRef } from "react";
import {
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  FormLabel,
  IconButton,
  Radio,
  RadioGroup,
  Rating,
  TextareaAutosize,
  TextField
} from "@mui/material";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  findProductById,
  getAllProducts,
  getAllProductsByCategory
} from "../../State/Product/Action";
import { addItemToCart, buyNowItem } from "../../State/Cart/Action";
import { getUser } from "../../State/Auth/Action";
import { toast } from "react-toastify";
import { createReview, getAllReview } from "../../State/Review/Action";
import {
  ChevronRight,
  CreditCard,
  Favorite,
  FavoriteBorder,
  Share,
  ShoppingCart
} from "@mui/icons-material";
import AuthModal from "../../Auth/AuthModal";
import SimilarProductCarousel from "../SimilarProducts/SimilarProductCarousel";
import MatchingOutfitCarousel from "../MatchinOutfitCarousel/MatchingOutfitCarousel";
import RecomendedProductsCarousel from "./RecomendedProductsCarousel";
import CloseIcon from "@mui/icons-material/Close";
import ShareModal from "./ShareModal";
import { addItemToWishlist, isWishlistItemExist, removeWishlistItem } from "../../State/Wishlist/Action";
import Loader from "../Loader/Loader";
import { processProductImages } from "../../../utils/imageUtils";
import { useConvertPrice } from "../../../Hooks/useConvertPrice";
import RecentReviewProductsCarousel from './../RecentReviewProductsCarousel/RecentReviewProductsCarousel';
import defaultImage from "../../../Common/productDefaultImage.png"

export default function ProductDetails() {
  const navigate = useNavigate();
  const params = useParams();
  const dispatch = useDispatch();
  const { products, reviews, cart, auth } = useSelector((store) => store);
  const jwt = localStorage.getItem("jwt");
  const role = localStorage.getItem("role");

  // Process product images to replace localhost URLs
  const processedProduct = processProductImages(products.product);
  const [selectedSize, setSelectedSize] = useState(null);
  const [selectedColor, setSelectedColor] = useState(null);
  const [ratingsDistribution, setRatingsDistribution] = useState({}); // Ratings breakdown
  const [open, setOpen] = useState(false);
  const [review, setReview] = useState("");
  const [openAuthModal, setOpenAuthModal] = useState(false);
  const [sizeError, setSizeError] = useState(false);
  const [colorError, setColorError] = useState(false);
  const [hoveredImage, setHoveredImage] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const { convert, customerPriceWithCharge, payableAmount, selectedCurrency } = useConvertPrice();
  const [stock, setStock] = useState(1);
  const [allOutOfStock, setAllOutOfStock] = useState(false); // ✅ new state
  const [loadingProductId, setLoadingProductId] = useState(null);
  const [isBuyNow, setIsBuyNow] = useState(false);

  const [isZoomOpen, setIsZoomOpen] = useState(false);
  const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 });
  const [showCursor, setShowCursor] = useState(false);
  const canvasRef = useRef(null);
  const cachedImageRef = useRef(null);

  const [openShare, setOpenShare] = useState(false);
  const [isFullScreenOpen, setIsFullScreenOpen] = useState(false);
  const { wishlist } = useSelector((store) => store);

  const saveRecentProduct = (productId) => {
    let ids = JSON.parse(localStorage.getItem("recentProductIds") || "[]");

    // Agar pehle se exist ho to remove
    ids = ids.filter((id) => id !== productId);

    // New ID ko top pe daalo
    ids.unshift(productId);

    // Max 15 hi store karna
    ids = ids.slice(0, 15);

    localStorage.setItem("recentProductIds", JSON.stringify(ids));
  };

  // Without backend → use current page URL
  const currentUrl = window.location.href;

  const handleMouseEnter = () => {
    setIsZoomOpen(true);
    setShowCursor(true);
  };

  const handleMouseLeave = () => {
    setIsZoomOpen(false);
    setShowCursor(false);
  };

  const handleMouseMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const newPosition = {
      x: Math.max(152, Math.min(e.clientX - rect.left, rect.width - 152)),
      y: Math.max(152, Math.min(e.clientY - rect.top, rect.height - 152)),
    };
    setCursorPosition(newPosition);

    // Draw zoomed image on canvas
    if (isZoomOpen && canvasRef.current) {
      drawZoomedImage(newPosition);
    }
  };

  const drawZoomedImage = (position) => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    // Resize canvas to match container dimensions
    const container = canvas.parentElement;
    canvas.width = container.clientWidth;
    canvas.height = container.clientHeight;

    // Use cached image if available, otherwise load and cache it
    if (cachedImageRef.current && cachedImageRef.current.complete) {
      drawImageOnCanvas(cachedImageRef.current, position, canvas, ctx);
    } else {
      const img = new Image();
      img.src = hoveredImage || selectedImage || mainImageUrl;
      img.onload = () => {
        cachedImageRef.current = img;
        drawImageOnCanvas(img, position, canvas, ctx);
      };
    }
  };

  const drawImageOnCanvas = (img, position, canvas, ctx) => {
    // Clear canvas
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Get the actual image dimensions from the left panel
    const leftImage = document.querySelector('.main-image img');
    const leftRect = leftImage?.getBoundingClientRect();

    // Calculate the scale factor between the displayed image and actual image
    const scaleX = img?.width / leftRect?.width;
    const scaleY = img?.height / leftRect?.height;

    // Convert cursor position to actual image coordinates
    const actualX = position.x * scaleX;
    const actualY = position.y * scaleY;

    // Calculate the area to crop (300x300 square around cursor)
    const cropSize = 300 * scaleX; // Scale the crop size to match image
    const cropX = Math.max(0, actualX - cropSize / 2);
    const cropY = Math.max(0, actualY - cropSize / 2);

    // Force the cropped area to fill the entire canvas (no extra space)
    const destWidth = canvas.width;
    const destHeight = canvas.height;

    // Position to fill full canvas (no margins anywhere)
    const destX = 0;
    const destY = 0;

    // Draw the cropped and scaled image to fill entire canvas
    ctx.drawImage(
      img,
      cropX, cropY, cropSize, cropSize,  // Source: crop area
      destX, destY, destWidth, destHeight // Destination: full canvas, no margins
    );
  };

  // add size dialog box start
  const [openSizeDialog, setOpenSizeDialog] = useState(false);
  const [isCustomTailor, setIsCustomTailor] = useState(false);
  const [unit, setUnit] = useState("cm");
  const category = products?.product?.category?.name?.toLowerCase();


  const [customSize, setCustomSize] = useState({
    //men or woemn common
    shoulder: "",
    waist: "",
    hip: "",
    //women
    topLength: "",
    bust: "",
    bottomLength: "",
    underBust: "",
    kurtsLength: "",
    armhole: "",
    frontNeckDepth: "",
    sleeveLength: "",
    backNeckDepth: "",
    bicep: "",
    crotchLength: "",
    elbow: "",
    thighCircumference: "",
    wrist: "",
    kneeCircumference: "",
    calfCircumference: "",
    lowerWaist: "",
    ankleCircumference: "",
    //men
    waistToKnee: "",
    chest: "",
    kneeLine: "",
    frontShoulderToWaist: "",
    neckCircumference: "",
    napeToWaist: "",
    armLength: "",
    backWidth: "",
    topArmCircumference: "",
    crotchDepth: "",
    waistToFloor: "",
    //common
    email: "",
    phone: "",
  });

  // confirmation checkbox
  const [confirmDetails, setConfirmDetails] = useState(false);

  // field change
  const handleCustomSizeChange = (e) => {
    const { name, value } = e.target;
    setCustomSize((prev) => ({ ...prev, [name]: value }));
  };

  const handleOpenSizeDialog = () => setOpenSizeDialog(true);
  const handleCloseSizeDialog = () => {
    setOpenSizeDialog(false);
    // Reset Form
    setCustomSize({
      //men or woemn common
      shoulder: "",
      waist: "",
      hip: "",
      //women
      topLength: "",
      bust: "",
      bottomLength: "",
      underBust: "",
      kurtsLength: "",
      armhole: "",
      frontNeckDepth: "",
      sleeveLength: "",
      backNeckDepth: "",
      bicep: "",
      crotchLength: "",
      elbow: "",
      thighCircumference: "",
      wrist: "",
      kneeCircumference: "",
      calfCircumference: "",
      lowerWaist: "",
      ankleCircumference: "",
      //men
      waistToKnee: "",
      chest: "",
      kneeLine: "",
      frontShoulderToWaist: "",
      neckCircumference: "",
      napeToWaist: "",
      armLength: "",
      backWidth: "",
      topArmCircumference: "",
      crotchDepth: "",
      waistToFloor: "",
      //common
      email: "",
      phone: "",
    });
    setConfirmDetails(false);
  };

  const handleAddCustomSize = () => {
    if (!customSize) {
      toast.error("Please fill custom size details.");
      return;
    }

    if (!confirmDetails) {
      alert("Please confirm your details before submitting.");
      return;
    }

    // ✅ Email check
    if (!customSize.email || !/\S+@\S+\.\S+/.test(customSize.email)) {
      alert("⚠️ Please enter a valid email.");
      return;
    }

    // ✅ Phone check
    if (!customSize.phone || customSize.phone.length < 10) {
      alert("⚠️ Please enter a valid phone number.");
      return;
    }

    // Payload with productId and unit
    const formattedData = {
      productId: products.product.id,
      unit,
      ...customSize,
    };

    let savedSizes = JSON.parse(localStorage.getItem("customSizes")) || {};
    savedSizes[products.product.id] = formattedData;

    localStorage.setItem("customSizes", JSON.stringify(savedSizes));

    toast.success("🎉 Custom size saved successfully!!");
    // Close Dialog
    handleCloseSizeDialog();
  };


  const handleColorSelect = (color) => {
    setSelectedColor(color);
    setColorError(false); // Clear error when size is selected
    // ✅ Check stock of all variants for selected color
    const filteredVariants = products.product?.variants?.filter(
      (item) => item?.productColor?.color?.name === color
    ) || [];

    const outOfStock = filteredVariants.every(
      (item) => (item?.stockQuantity || 0) <= 0
    );

    setAllOutOfStock(outOfStock);

    // Update image
    setSelectedImage(
      processedProduct?.images?.find(
        (image) => image.productColor?.color?.name === color && image.isPrimary
      )?.fullUrl || ""
    );
  };
  const handleSizeSelect = (size) => {
    setSelectedSize(size);
    setSizeError(false); // Clear error when size is selected
    const selectedVariant = products.product?.variants?.find(
      (item) =>
        item.size.name === size &&
        item?.productColor?.color?.name === selectedColor
    );
    setStock(selectedVariant?.stockQuantity)
  };

  useEffect(() => {
    dispatch(getAllProducts());
    if (params.productId) {
      dispatch(findProductById(params.productId, selectedCurrency));
      dispatch(getAllReview(params.productId)); // Fetch reviews once when productId changes
      setSelectedImage(""); // Reset selected image on product change
      // canvasRef.current = null;
      cachedImageRef.current = null;
    }
  }, [dispatch, params.productId, reviews.createdReview, reviews.deletedReview, selectedCurrency]);

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when component mounts
  }, [params.productId]);

  // Opens login modal
  const handleOpenAuthModal = () => setOpenAuthModal(true);
  const handleCloseAuthModal = () => setOpenAuthModal(false);

  useEffect(() => {
    const availableColors = processedProduct?.colors || [];
    const defaultColor =
      availableColors.find((c) => c?.color?.name?.toLowerCase() === "white")?.color?.name ||
      availableColors.find((c) => c?.color?.name?.toLowerCase() === "black")?.color?.name ||
      availableColors[0]?.color?.name || null;

    setSelectedColor(defaultColor);

    // ✅ Check stock of all variants for selected color
    const filteredVariants = products.product?.variants?.filter(
      (item) => item?.productColor?.color?.name === defaultColor
    ) || [];

    const outOfStock = filteredVariants.every(
      (item) => (item?.stockQuantity || 0) <= 0
    );

    setAllOutOfStock(outOfStock);
  }, [processedProduct?.colors, products.product?.variants]);

  useEffect(() => {
    if (products.product) {
      saveRecentProduct(products.product.id);
    }
  }, [products.product]);

  const mainImageUrl = (processedProduct?.images || []).find((img) => img.isPrimary && img.productColor?.color?.name === selectedColor)?.fullUrl;

  useEffect(() => {
    const saved = localStorage.getItem("pendingProductSelection");

    if (saved && products.product?.variants) {
      const { color, size, productId, buyNow } = JSON.parse(saved);
      const submitItem = buyNow ? buyNowItem : addItemToCart;

      if (productId === params.productId && color && size) {

        // ✅ Case 4: Check Custom Size
        const savedSizes = JSON.parse(localStorage.getItem("customSizes")) || {};

        // direct key access
        const savedCustomSize = savedSizes[products?.product?.id] || null;

        if (isCustomTailor) {
          if (!savedCustomSize) {
            toast.error("⚠️ Please add your custom size before proceeding.");
            return;
          }

          const selectedVariant = products.product?.variants
            ?.filter((item) => item?.productColor?.color?.name === selectedColor) // ✅ same color wale sab variants
            ?.reduce((maxVariant, current) => {
              return current.customerPrice > (maxVariant?.customerPrice || 0)
                ? current
                : maxVariant;
            }, null); // ✅ sabse zyada price wala variant

          const data = {
            size: size,
            color: color,
            quantity: 1,
            // additionalChargePercentage: additionalCharge(selectedCurrency, selectedVariant.customerPrice),
            customerPriceWithCharge: selectedVariant?.customerPrice,
            selectedCurrency: selectedCurrency,
          };

          if (data.size && data.color && params.productId && selectedVariant?.id) {
            dispatch(submitItem(params.productId, selectedVariant.id, data, navigate));
            localStorage.removeItem("pendingProductSelection");
          } else {
            toast.error("Something went wrong while adding custom size product.");
          }
          return; // ✅ prevent further execution
        }

        const selectedVariant = products.product.variants.find((item) => {
          const itemSize = item?.size?.name?.toLowerCase();
          const itemColor = item?.productColor?.color?.name?.toLowerCase();

          return (
            itemSize === size.toLowerCase() &&
            itemColor === color.toLowerCase()
          );
        });

        if (!selectedVariant || selectedVariant.stockQuantity < 1) {
          toast("Selected size is out of stock.");
          return;
        }

        const data = {
          size: size,
          color: color,
          quantity: 1,
          // additionalChargePercentage: additionalCharge(selectedCurrency, selectedVariant.customerPrice),
          customerPriceWithCharge: selectedVariant?.customerPrice,
          selectedCurrency: selectedCurrency,
        };

        dispatch(submitItem(productId, selectedVariant.id, data, navigate));
        localStorage.removeItem("pendingProductSelection");
      }
    }
  }, [params.productId, products.product, auth?.jwt]);



  const handleAddToCart = (mode = "cart") => {
    const isBuyNowFlow = mode === "buyNow";
    const pendingSelection = {
      color: selectedColor,
      size: selectedSize,
      productId: products?.product?.id,
      buyNow: isBuyNowFlow,
    };

    // ✅ Case 1: User not logged in
    if (!jwt) {
      localStorage.setItem("pendingProductSelection", JSON.stringify(pendingSelection));
      handleOpenAuthModal();
      return;
    }

    // ✅ Case 2: Logged in but not CUSTOMER
    if (role !== "CUSTOMER") {
      localStorage.setItem("pendingProductSelection", JSON.stringify(pendingSelection));
      handleOpenAuthModal();
      return;
    }

    // ✅ Case 3: Logged in as CUSTOMER → allow add to cart
    if (!selectedColor) {
      setColorError(true);
      setIsBuyNow(false)
      return;
    }

    if (!selectedSize) {
      setSizeError(true);
      setIsBuyNow(false)
      return;
    }

    // ✅ Case 4: Check Custom Size
    const savedSizes = JSON.parse(localStorage.getItem("customSizes")) || {};

    // direct key access
    const savedCustomSize = savedSizes[products?.product?.id] || null;

    const submitItem = isBuyNowFlow ? buyNowItem : addItemToCart;
    setIsBuyNow(isBuyNowFlow);

    if (isCustomTailor) {
      if (!savedCustomSize) {
        toast.error("⚠️ Please add your custom size before proceeding.");
        setIsBuyNow(false)
        return;
      }

      const selectedVariant = products.product?.variants
        ?.filter((item) => item?.productColor?.color?.name === selectedColor) // ✅ same color wale sab variants
        ?.reduce((maxVariant, current) => {
          return current.customerPrice > (maxVariant?.customerPrice || 0)
            ? current
            : maxVariant;
        }, null); // ✅ sabse zyada price wala variant

      const data = {
        size: selectedSize,
        color: selectedColor,
        quantity: 1,
        // additionalChargePercentage: additionalCharge(selectedCurrency, selectedVariant.customerPrice),
        customerPriceWithCharge: selectedVariant?.customerPrice,
        selectedCurrency: selectedCurrency,
      };

      if (data.size && data.color && params.productId && selectedVariant?.id) {
        dispatch(submitItem(params.productId, selectedVariant.id, data, navigate));
        localStorage.removeItem("pendingProductSelection");
      } else {
        toast.error("Something went wrong while adding custom size product.");
        setIsBuyNow(false)
      }
      return; // ✅ prevent further execution
    }

    const selectedVariant = products.product?.variants?.find(
      (item) =>
        item.size.name === selectedSize &&
        item?.productColor?.color?.name === selectedColor
    );

    if (!selectedVariant || selectedVariant.stockQuantity < 1) {
      toast("Selected size is out of stock.");
      setIsBuyNow(false)
      return;
    }

    const data = {
      size: selectedSize,
      color: selectedColor,
      quantity: 1,
      // additionalChargePercentage: additionalCharge(selectedCurrency, selectedVariant.customerPrice),
      customerPriceWithCharge: selectedVariant?.customerPrice,
      selectedCurrency: selectedCurrency,
    };
    // ✅ Safety check: ensure all fields exist before dispatch
    if (data.size && data.color && params.productId && selectedVariant?.id) {
      dispatch(submitItem(params.productId, selectedVariant.id, data, navigate));
      localStorage.removeItem("pendingProductSelection");
    } else {
      console.error("Add to cart failed: invalid data", { data, productId: params.productId, variantId: selectedVariant?.id });
      toast.error("Something went wrong while adding to cart.");
      setIsBuyNow(false)
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClickClose = () => {
    setOpen(false);
    setReview("");
  };

  useEffect(() => {
    const productCategory = products.product?.productCategory?.name;
    const category = products.product?.category?.name;

    if (productCategory && category) {
      dispatch(getAllProductsByCategory(productCategory, category));
    }
  }, [
    dispatch,
    products.product?.productCategory?.name,
    products.product?.category?.name,
    params.productId
  ]);

  useEffect(() => {
    if (products.product?.reviews) {
      calculateRatingsDistribution(products.product.reviews);
    }
  }, [
    products.product?.reviews,
    params.productId,
    reviews.createdReview,
    reviews.deletedReview
  ]);

  useEffect(() => {
    if (jwt && role === "CUSTOMER") {
      dispatch(getUser(jwt));
    }
  }, [jwt, dispatch, role]);

  // Rating distribution calculation function
  const calculateRatingsDistribution = (reviews) => {
    const distribution = {
      excellent: 0,
      veryGood: 0,
      good: 0,
      average: 0,
      poor: 0
    };
    if (reviews?.length > 0) {
      reviews?.forEach((review) => {
        if (review?.rating === 5) distribution.excellent++;
        else if (review?.rating === 4) distribution.veryGood++;
        else if (review?.rating === 3) distribution.good++;
        else if (review?.rating === 2) distribution.average++;
        else if (review?.rating === 1) distribution.poor++;
      });
    }

    const totalReviews = reviews?.length;
    if (totalReviews > 0) {
      for (let key in distribution) {
        distribution[key] = (distribution[key] / totalReviews) * 100; // Convert to percentages
      }
    }
    setRatingsDistribution(distribution);
  };

  const capitalizeWords = (str) =>
    str?.replace(/\b\w/g, char => char?.toUpperCase());

  const [isInWishlist, setIsInWishlist] = useState(false);
  const wishlistLoading = useSelector((state) => state.wishlist.loading);

  useEffect(() => {
    if (jwt && role === "CUSTOMER" && params.productId) {
      dispatch(isWishlistItemExist(params.productId)).then((exists) => {
        if (typeof exists === "boolean") {
          setIsInWishlist(exists);
        }
      });
    }
  }, [dispatch, params.productId, jwt, role, wishlist?.deletedWishlistItem, wishlist?.addWislistItem]);

  const handleFavorite = async (e) => {
    e.stopPropagation();
    e.preventDefault();

    // ✅ Product ID Save for later action
    const productId = params.productId;

    setLoadingProductId(productId); // ✅ सिर्फ इसी card को loading बनाओ

    try {
      if (!jwt || role !== "CUSTOMER") {
        sessionStorage.setItem("pendingWishlistProduct", productId);
        handleOpenAuthModal();
        return;
      }

      if (isInWishlist) {
        await dispatch(removeWishlistItem(productId));
        setIsInWishlist(false);
        setLoadingProductId(null); // ✅ काम पूरा होने पर reset
      } else {
        await dispatch(addItemToWishlist(productId));
        setIsInWishlist(true);
        setLoadingProductId(null); // ✅ काम पूरा होने पर reset
      }
    } finally {
      setLoadingProductId(null); // ✅ काम पूरा होने पर reset
    }
  };

  useEffect(() => {
    const pendingProductId = sessionStorage.getItem("pendingWishlistProduct");
    if (pendingProductId && jwt && role === "CUSTOMER") {
      dispatch(addItemToWishlist(pendingProductId));
      setIsInWishlist(true);
      sessionStorage.removeItem("pendingWishlistProduct");
    }
  }, [jwt, role]);

  const handleNotify = () => {
    const productId = params.productId
    // यहाँ पर बाकी logic डालें
    if (productId) {
      try {
        if (!jwt || role !== "CUSTOMER") {
          sessionStorage.setItem("pendingWishlistProduct", productId);
          handleOpenAuthModal();
          return;
        }
        dispatch(addItemToWishlist(productId));
        setIsInWishlist(true);
      } finally {
        setLoadingProductId(null); // ✅ काम पूरा होने पर reset
      }
    }
  };

  useEffect(() => {
    // Clear cached image when selected image changes
    if (cachedImageRef.current) {
      cachedImageRef.current = null;
    }
  }, [selectedImage, hoveredImage]);

  return (
    products?.getByIdLoading ? <Loader /> : (
      <div className="bg-white py-4 font-sans text-[#333]">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          {/* Breadcrumb */}
          <nav className="mb-4 flex text-[12px] font-light text-[#8a8a8a]">
            <ol className="flex items-center space-x-1">
              <li>
                <Link
                  to="/"
                  className="hover:text-[#BB3D1F]"
                >
                  Home
                </Link>
              </li>
              <li className="flex items-center space-x-1">
                <ChevronRight className="h-3.5 w-3.5 text-[#cfcfcf]" />
                <Link
                  to={`/${products.product?.category?.name}`}
                  className="hover:text-[#BB3D1F]"
                >
                  {products.product?.category?.name}
                </Link>
              </li>
              <li className="flex items-center space-x-1">
                <ChevronRight className="h-3.5 w-3.5 text-[#cfcfcf]" />
                <Link
                  to={`/${products.product?.category?.name}`}
                  className="hover:text-[#BB3D1F]"
                >
                  {products.product?.subCategory?.name}
                </Link>
              </li>
              <li className="flex items-center space-x-1">
                <ChevronRight className="h-3.5 w-3.5 text-[#cfcfcf]" />
                <Link
                  to={`/${products.product?.category?.name}/${products.product?.subCategory?.name}/${products.product?.productCategory?.name}`}
                  className="font-normal text-[#333]"
                >
                  {products.product?.productCategory?.name}
                </Link>
              </li>
            </ol>
          </nav>
          <div className="product-details flex w-full flex-col gap-4 lg:flex-row lg:gap-8">
            {/* Mobile: Hide thumbnails, Desktop: Show thumbnails */}
            <div className="image-gallery hidden lg:flex lg:flex-col">
              {/* Image thumbnails */}
              <div className="flex max-h-[80vh] w-24 flex-col space-y-2 overflow-y-auto scrollbar-hide">
                {(processedProduct?.images || [])
                  // Step 1: filter by selected color
                  .filter((image) => image.productColor?.color?.name === selectedColor)
                  // Step 2: sort -> primary images first
                  .sort((a, b) => (b.isPrimary ? 1 : 0) - (a.isPrimary ? 1 : 0))
                  .map((image) => (
                    <div
                      key={image.id}
                      className={`h-[7.5rem] w-[5.5rem] flex-shrink-0 cursor-pointer overflow-hidden rounded-xl bg-[#f6f2ed] ${selectedImage === image.fullUrl || (!selectedImage && image.isPrimary)
                        ? "ring-1 ring-[#333]"
                        : "ring-1 ring-transparent hover:ring-[#d8d2cc]"
                        }`}
                      onClick={() => setSelectedImage(image.fullUrl)}
                      onMouseEnter={() => setHoveredImage(image.fullUrl)}
                      onMouseLeave={() => setHoveredImage(null)}
                    >
                      <img
                        alt={image.fullUrl}
                        src={image.fullUrl || defaultImage}
                        className="h-full w-full object-cover object-center"
                      />
                    </div>
                  ))}
              </div>
            </div>
            <div className="main-image relative flex flex-col gap-4 lg:flex-row lg:gap-8">
              {/* Mobile: Full width image, Desktop: Left side image */}
              <div
                style={{ cursor: showCursor ? "none" : "default" }}
                className="relative flex h-[32rem] w-full overflow-hidden rounded-2xl bg-[#f6f2ed] sm:h-[36rem] lg:h-[45rem] lg:w-[30rem]"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                onMouseMove={handleMouseMove}
                onClick={() => {
                  // On mobile, open full screen on click
                  if (window.innerWidth < 1024) {
                    setIsFullScreenOpen(true);
                  }
                }}
              >
                {/* Base Image */}
                <img
                  className="h-full w-full object-cover object-center"
                  src={hoveredImage || selectedImage || mainImageUrl || defaultImage}
                  alt="Product"
                />

                {/* Cursor overlay with square box */}
                {showCursor && (
                  <div
                    className="absolute inset-0 z-10 pointer-events-none"
                    style={{
                      backgroundColor: "rgba(0,0,0,0.4)",
                      clipPath: `polygon(
                    0 0,
                    100% 0,
                    100% 100%,
                    0 100%,
                    0 0,
                    ${cursorPosition.x - 150}px ${cursorPosition.y - 150}px,
                    ${cursorPosition.x - 150}px ${cursorPosition.y + 150}px,
                    ${cursorPosition.x + 150}px ${cursorPosition.y + 150}px,
                    ${cursorPosition.x + 150}px ${cursorPosition.y - 150}px,
                    ${cursorPosition.x - 150}px ${cursorPosition.y - 150}px
                  )`,
                    }}
                  />
                )}

              </div>

              {/* Mobile Thumbnails - Show below main image on mobile */}
              <div className="mt-3 flex gap-2 overflow-x-auto scrollbar-hide lg:hidden">
                {(processedProduct?.images || [])
                  .filter((image) => image.productColor?.color?.name === selectedColor)
                  .sort((a, b) => (b.isPrimary ? 1 : 0) - (a.isPrimary ? 1 : 0))
                  .map((image) => (
                    <div
                      key={image.id}
                      className={`h-20 w-16 flex-shrink-0 cursor-pointer overflow-hidden rounded-xl bg-[#f6f2ed] ${selectedImage === image.fullUrl
                        ? "ring-1 ring-[#333]"
                        : !selectedImage && image.isPrimary
                          ? "ring-1 ring-[#333]"
                          : "ring-1 ring-transparent"
                        }`}
                      onClick={() => setSelectedImage(image.fullUrl)}
                      onMouseEnter={() => setHoveredImage(image.fullUrl)}
                      onMouseLeave={() => setHoveredImage(null)}
                    >
                      <img
                        alt={image.fullUrl}
                        src={image.fullUrl}
                        className="h-full w-full object-cover object-center"
                      />
                    </div>
                  ))}
              </div>

              {/* Mobile: Below image, Desktop: Right side */}
              <div className="relative flex-1 w-full lg:min-w-[705px]">
                {/* Zoom Overlay */}
                {isZoomOpen && (
                  <div
                    className="absolute w-full h-full border-2 border-gray-300 overflow-hidden z-50 bg-white flex items-center justify-center"
                    style={{
                      position: "absolute",
                      left: "0",
                      top: "0",
                      width: "100%",
                      height: "100%",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        overflow: "hidden",
                        position: "relative",
                      }}
                    >
                      <canvas
                        ref={canvasRef}
                        width={800}
                        height={600}
                        style={{
                          width: "100%",
                          height: "100%",
                          display: "block",
                        }}
                      />
                    </div>
                  </div>
                )}

                {/* Product Info Content */}
                <div className="product-info relative z-10 w-full px-1 lg:px-0">
                  <div className="flex w-full justify-between">
                    {/* Brand Name */}
                    <Link
                      to={`/collections/brand/${processedProduct?.brand?.name}`}
                      className="font-display word-break text-[22px] italic leading-7 text-[#333] hover:text-[#BB3D1F]"
                      style={{ fontFamily: "'Playfair Display', Georgia, serif" }}
                    >
                      {processedProduct?.brand?.name}
                    </Link>
                  </div>

                  {/* Wishlist Icon - Positioned at the rightmost edge */}
                  <button
                    onClick={handleFavorite}
                    className="group/heart absolute right-0 top-0 z-20 border-0 bg-transparent p-0 hover:bg-transparent"
                    disabled={loadingProductId === params?.productId || wishlistLoading}
                  >
                    {loadingProductId === params?.productId && wishlistLoading ? (
                      <span className="inline-block h-5 w-5 animate-spin rounded-full border-[3px] border-stone-400 border-t-transparent"></span>
                    ) : isInWishlist ? (
                      <Favorite className="text-red-500" />
                    ) : (
                      <FavoriteBorder className="text-stone-400 group-hover/heart:text-red-500" />
                    )}
                  </button>
                  <p className="mt-1 text-[15px] font-light leading-6 text-[#707070]">{capitalizeWords(processedProduct?.title)}</p>
                  <div className="mt-1 flex items-center text-[13px] text-[#8a8a8a]">
                    <Rating
                      value={reviews.reviews?.averageRating || 0}
                      precision={0.5}
                      readOnly
                      size="small"
                      sx={{ "& .MuiRating-iconFilled": { color: "#BB3D1F" } }}
                    />
                    <p className="ms-1 font-light">
                      {reviews.reviews?.reviewCount || 0} Reviews
                    </p>
                  </div>
                  {(() => {
                    const variants = processedProduct?.variants || [];

                    // Try to find variant based on selected color and size
                    const matchedVariant = variants.find(
                      (v) => v?.productColor?.color?.name === selectedColor && v?.size?.name === selectedSize
                    );

                    // If matched variant is found, show its pricing
                    const displayVariant = matchedVariant
                      ? matchedVariant
                      : isCustomTailor
                        ? variants.reduce((max, curr) =>
                          curr?.adminPrice > max?.adminPrice ? curr : max
                          , variants[0])
                        : variants.reduce((min, curr) =>
                          curr?.adminPrice < min?.adminPrice ? curr : min
                          , variants[0]);

                    if (!displayVariant) return null;

                    return displayVariant.viewTotalDiscount === 0 ? (
                      <>
                        <p className="mt-4 text-[20px] font-semibold text-[#333]">
                          {convert(customerPriceWithCharge(selectedCurrency, displayVariant.viewPayableAmount))} {selectedCurrency}
                        </p>
                        <p className="mt-1 text-[12px] font-light text-[#8a8a8a]">inclusive of all taxes</p>
                        {isCustomTailor && <p className="mt-1 text-[12px] text-[#BB3D1F]">Customization Charge : {convert(products?.product?.customizationPrice)} {selectedCurrency} </p>}
                      </>
                    ) : (
                      <>
                        <p className="mt-4 text-[20px] font-semibold text-[#333]">
                          {payableAmount(customerPriceWithCharge(selectedCurrency, displayVariant.viewCustomerAmount), displayVariant.viewTotalDiscount)} {selectedCurrency}
                          <span className="ml-2 text-[15px] font-light text-[#9a9a9a] line-through">
                            {convert(customerPriceWithCharge(selectedCurrency, displayVariant.viewCustomerAmount))} {selectedCurrency}
                          </span>
                          <span className="ml-2 text-[14px] font-medium text-[#2f9e44]">
                            {displayVariant.viewTotalDiscount}% OFF
                          </span>
                        </p>
                        <p className="mt-1 text-[12px] font-light text-[#8a8a8a]">inclusive of all taxes</p>
                        {isCustomTailor && <p className="mt-1 text-[12px] text-[#BB3D1F]">Customization Charge : {convert(products?.product?.customizationPrice)} {selectedCurrency} </p>}
                      </>
                    );
                  })()}
                  {/* color Selector */}
                  <div className="size-selector mt-6">
                    <p className="text-[13px] font-medium tracking-wide text-[#333]">Select your color</p>

                    <div className="mt-2 flex flex-wrap gap-2">
                      {processedProduct?.colors?.map((item) => (
                        <button
                          key={item?.color?.name}
                          className={`rounded-lg border px-4 py-2 text-[12px] uppercase tracking-wide
          ${item?.color?.name === selectedColor
                              ? "border-[#333] bg-[#333] text-white"
                              : colorError && !selectedColor
                                ? "border-[#BB3D1F] bg-white text-[#BB3D1F]"
                                : "border-[#ececec] bg-white text-[#333] hover:border-[#d8d2cc]"
                            }
        `}
                          onClick={() => handleColorSelect(item?.color?.name)}
                        >
                          {item?.color?.name || "No Color"}
                        </button>
                      ))}
                    </div>

                    {colorError && !selectedColor && (
                      <p className="text-red-500 text-xs mt-2">* Please select a color.</p>
                    )}
                  </div>
                  {/* size  */}
                  <div className="size-selector mt-2">
                    <div className="flex items-center">
                      <p className="me-2 text-[13px] font-medium tracking-wide text-[#333]">Select your size</p>
                    </div>

                    {/* Sizes */}
                    <div className="flex flex-wrap gap-2 mt-2">
                      {[...new Map(
                        (processedProduct?.variants || [])
                          .filter((v) =>
                            selectedColor ? v.productColor?.color?.name === selectedColor : true
                          )
                          .map((item) => [item?.size?.name, item]) // unique size
                      ).values()].map((item) => {
                        const stock = item?.stockQuantity || 0; // ✅ stock count le lo
                        const isOutOfStock = stock <= 0;
                        const isLowStock = stock > 0 && stock <= 10;

                        return (
                          <div key={item?.size?.name} className="flex flex-col items-center">
                            {/* 🔹 Stock Label */}
                            {isOutOfStock ? (
                              <span className="text-[10px] text-red-500 font-medium mb-0.5">Out of Stock</span>
                            ) : isLowStock ? (
                              <span className="text-[10px] text-orange-500 font-medium mb-0.5">
                                {stock} left
                              </span>
                            ) : <span className="text-[10px] opacity-0 mb-0.5">.</span>}

                            {/* 🔹 Size Button */}
                            <button
                              disabled={isOutOfStock}
                              className={`rounded-lg border px-4 py-2 text-[12px] uppercase tracking-wide transition
            ${item?.size?.name === selectedSize
                                  ? "border-[#333] bg-[#333] text-white"
                                  : sizeError && !selectedSize
                                    ? "border-[#BB3D1F] bg-white text-[#BB3D1F]"
                                    : "border-[#ececec] bg-white text-[#333] hover:border-[#d8d2cc]"
                                }
            ${isOutOfStock ? "cursor-not-allowed opacity-50" : ""}
          `}
                              onClick={() => {
                                if (!isOutOfStock) {
                                  handleSizeSelect(item?.size?.name);
                                  setIsCustomTailor(false); // reset custom tailor flag
                                }
                              }}
                            >
                              {item?.size?.name}
                            </button>
                          </div>
                        );
                      })}
                      {/* Custom Tailor Button */}
                      {(category === "women" || category === "men") && products?.product?.customizationAllowed && (
                        <div className="flex flex-col items-center">
                          <span className="text-[10px] opacity-0 mb-0.5">.</span>
                          <button
                            key="custom-tailor"
                            className={`rounded-lg border px-4 py-2 text-[12px] uppercase tracking-wide transition
                           ${isCustomTailor
                                ? "border-[#333] bg-[#333] text-white"
                                : "border-[#ececec] bg-white text-[#333] hover:border-[#d8d2cc]"
                              }`}
                            onClick={() => {
                              setIsCustomTailor(true);         // mark custom tailor selected
                              setSelectedSize("Custom Tailor"); // set virtual size
                              handleOpenSizeDialog();           // open custom size form popup
                            }}
                          >
                            Custom Tailor
                          </button>
                        </div>
                      )}
                    </div>

                    {/* Error only if neither size nor custom tailor selected */}
                    {sizeError && !selectedSize && !isCustomTailor && (
                      <p className="text-red-500 text-xs mt-2">* Please select a size.</p>
                    )}
                    {!sizeError && selectedSize && isCustomTailor && (
                      <p className="text-green-500 text-xs mt-2">Custom Size are saved and Customization Charge is : {convert(products?.product?.customizationPrice)} {selectedCurrency} <br />
                        Please add to cart and then placed order with Custom Tailor.</p>
                    )}
                  </div>

                  {/* Action Buttons */}
                  <div className="mt-6 flex flex-col space-y-2 sm:flex-row sm:space-x-3 sm:space-y-0">
                    {allOutOfStock || stock <= 0 ? (
                      <>
                        <button
                          className="flex cursor-not-allowed items-center justify-center gap-2 rounded-lg bg-[#ececec] px-4 py-3 text-[12px] font-semibold tracking-wide text-[#BB3D1F]"
                          disabled
                        >
                          OUT OF STOCK
                        </button>
                        <button
                          type="button"
                          onClick={handleNotify}
                          className="flex items-center justify-center gap-2 rounded-lg border border-[#333] bg-white px-4 py-3 text-[12px] font-semibold tracking-wide text-[#333] transition-colors hover:bg-[#333] hover:text-white"
                        >
                          NOTIFY
                        </button>
                      </>
                    ) : (
                      <>
                        <button
                          className="flex items-center justify-center gap-2 rounded-lg bg-[#BB3D1F] px-5 py-3 text-[12px] font-semibold tracking-wide text-white transition-colors hover:bg-[#9e3319] disabled:opacity-60"
                          onClick={() => handleAddToCart("buyNow")}
                          disabled={cart?.addLoading}
                        >
                          {(cart?.addLoading && isBuyNow) ? (
                            <>
                              PROCESSING....
                              <CircularProgress
                                size={18}
                                sx={{
                                  color: "#fff",
                                }}
                              />
                            </>
                          ) : (
                            <>
                              <CreditCard size={16} style={{ marginRight: 6 }} />
                              BUY NOW
                            </>
                          )}

                        </button>

                        <button
                          className="relative flex items-center justify-center gap-2 rounded-lg border border-[#333] bg-white px-5 py-3 text-[12px] font-semibold tracking-wide text-[#333] transition-colors hover:bg-[#333] hover:text-white disabled:opacity-60"
                          onClick={() => handleAddToCart("cart")}
                          disabled={cart?.addLoading}
                        >
                          {(cart?.addLoading && !isBuyNow) ? (
                            <>
                              ADDING....
                              <CircularProgress
                                size={18}
                                sx={{
                                  color: "#333",
                                }}
                              />
                            </>
                          ) : (
                            <>
                              <ShoppingCart size={16} style={{ marginRight: 6 }} />
                              ADD TO CART
                            </>
                          )}
                        </button>
                      </>
                    )}
                    <button
                      onClick={() => setOpenShare(true)}
                      className="flex items-center justify-center gap-2 rounded-lg border border-[#ececec] bg-white px-5 py-3 text-[12px] font-semibold tracking-wide text-[#333] transition-colors hover:border-[#d8d2cc] hover:bg-[#faf7f4]"
                    >
                      <Share size={16} /> SHARE
                    </button>

                    {openShare && <ShareModal url={currentUrl} onClose={() => setOpenShare(false)} open={openShare} />}
                  </div>

                  {/* Extra Info */}
                  <div className="mt-8 border-t border-[#ececec] pt-6">
                    <p className="text-[13px] font-medium tracking-wide text-[#333]">GET IN TOUCH</p>
                    <p className="mt-1 text-[13px] font-light leading-5 text-[#707070]">To know about any offers on this product</p>
                  </div>

                  <div className="mt-5">
                    <p className="text-[13px] font-medium tracking-wide text-[#333]">PRICE MATCH PROMISE</p>
                    <p className="mt-1 text-[13px] font-light leading-5 text-[#707070]">
                      If you find the product for less we'll match it! <span className="text-[#BB3D1F]">(T&C Applied)</span>
                    </p>
                  </div>

                  <div className="mt-5">
                    <p className="text-[13px] font-medium tracking-wide text-[#333]">PRODUCT DESCRIPTION</p>

                    {/* Product Description */}
                    <p className="mb-1 mt-1 text-[13px] font-light leading-5 text-[#707070]">
                      {products?.product?.description}
                    </p>

                    {/* Attributes */}
                    {products?.product?.attributes?.length > 0 && (
                      <div className="mt-1 space-y-1">
                        {products.product.attributes.map((attr, index) => (
                          <p key={index} className="text-[13px] font-light text-[#707070]">
                            <span className="font-medium text-[#333]">{attr?.name}:</span> {attr?.value}
                          </p>
                        ))}
                      </div>
                    )}
                  </div>
                  <div className="mt-5">
                    {/* Return Section */}
                    <p className="text-[13px] font-medium tracking-wide text-[#333]">RETURN POLICY</p>
                    <p className="mt-1 text-[13px] font-light leading-5 text-[#707070]">
                      {products?.product?.returnAllowed?.toLowerCase() === "yes" ? (
                        selectedSize === "Custom Tailor" ? "Return is not allowed for Custom Tailor product." :
                          <>
                            Return allowed within <span className="font-medium text-[#333]">2 days</span> after product delivery.{" "}
                            <a
                              href="/return-policy"
                              className="font-medium text-[#BB3D1F] hover:underline"
                            >
                              View Return Policy
                            </a><br />
                            Return not allowed for Custom Tailor product.
                          </>
                      ) : (
                        "Return is not allowed for this product."
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* rating and reviews - commented out for now */}

          {/* recent review products  */}
          <section className="py-4 mt-5">
            <RecentReviewProductsCarousel
              productId={products.product?.id}
              products={products.allProducts?.response}
            />
          </section>
        </div>

        {/*similar products */}
        <section className="py-4">
          <SimilarProductCarousel
            productId={products.product?.id}
            title={"SIMILAR PRODUCTS"}
            category={products.product?.category?.name}
            subCategory={products.product?.subCategory?.name}
            productCategory={products.product?.productCategory?.name}
          />
        </section>
        {/* matching products */}
        <section className="py-4">
          <MatchingOutfitCarousel
            productId={products.product?.id}
            title={"MATCHING PRODUCTS"}
            color={selectedColor || products?.product?.colors[0]?.color?.name}
            category={products.product?.category?.name}
            subCategory={products.product?.subCategory?.name}
            productCategory={products.product?.productCategory?.name}
          />
        </section>
        {/* recomended product */}
        <section className="py-4">
          <RecomendedProductsCarousel
            productId={products.product?.id}
            title={"TRENDING PRODUCTS"}
            productCategory={products.product?.productCategory?.name}
          />
        </section>

        {/* add review form dialog box */}
        <Dialog
          open={open}
          onClose={handleClickClose}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            component: "form",
            onSubmit: (event) => {
              event.preventDefault();
              const formData = new FormData(event.currentTarget);
              const formJson = Object.fromEntries(formData.entries());
              const message = formJson.message;
              const data = { review: message };
              dispatch(createReview(params.productId, data));
              handleClickClose();
            },
            sx: {
              borderRadius: '16px',
              boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
            },
          }}
        >
          <DialogTitle sx={{
            m: 0,
            p: 3,
            borderBottom: '1px solid #e5e7eb',
            backgroundColor: '#f9fafb'
          }}>
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-indigo-100 rounded-full flex items-center justify-center">
                <svg className="w-5 h-5 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
                </svg>
              </div>
              <div>
                <h2 className="text-xl font-semibold text-gray-800">Write a Review</h2>
                <p className="text-sm text-gray-600">Share your experience with this product</p>
              </div>
            </div>
          </DialogTitle>
          <DialogContent sx={{ p: 3 }}>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Your Review
                </label>
                <TextareaAutosize
                  autoFocus
                  required
                  minRows={4}
                  placeholder="Tell us what you think about this product... What did you like? What could be improved?"
                  id="message"
                  name="message"
                  onChange={(e) => setReview(e.currentTarget.value)}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 resize-none transition-colors duration-200"
                  style={{
                    fontSize: "14px",
                    lineHeight: "1.5"
                  }}
                />
              </div>
            </div>
          </DialogContent>
          <DialogActions sx={{ p: 3, borderTop: '1px solid #e5e7eb', backgroundColor: '#f9fafb' }}>
            <Button
              onClick={handleClickClose}
              sx={{
                color: '#6b7280',
                '&:hover': {
                  backgroundColor: '#f3f4f6'
                }
              }}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              disabled={!review.trim()}
              sx={{
                backgroundColor: '#4f46e5',
                color: 'white',
                px: 3,
                py: 1.5,
                borderRadius: '8px',
                '&:hover': {
                  backgroundColor: '#4338ca'
                },
                '&:disabled': {
                  backgroundColor: '#d1d5db',
                  color: '#9ca3af'
                }
              }}
            >
              Submit Review
            </Button>
          </DialogActions>
        </Dialog>

        {/* add size dialog box form start */}
        <Dialog
          open={openSizeDialog}
          onClose={handleCloseSizeDialog}
          maxWidth="md"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: "12px",
              boxShadow: "0 8px 30px rgba(0,0,0,0.1)",
            },
          }}
        >
          <DialogTitle sx={{ m: 0, p: 2 }}>
            <div className="flex items-center justify-between">
              <span className="font-semibold text-lg">Add Your Custom Size</span>
              <IconButton onClick={handleCloseSizeDialog}>
                <CloseIcon />
              </IconButton>
            </div>
          </DialogTitle>

          <DialogContent dividers>
            {/* 🔹 Grid Layout with Form + Image */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Left Side: Form */}
              <div>
                <div className="flex items-center gap-4 mb-6">
                  <FormLabel component="legend">Select Unit:</FormLabel>
                  <RadioGroup
                    row
                    value={unit}
                    onChange={(e) => setUnit(e.target.value)}
                  >
                    <FormControlLabel
                      value="cm"
                      control={<Radio />}
                      label="Centimeters"
                    />
                    <FormControlLabel
                      value="inch"
                      control={<Radio />}
                      label="Inches"
                    />
                  </RadioGroup>
                </div>
                {/* 🔹 Title */}
                <h6 className="text-md mb-1 mt-5">
                  Tell us about your body measurements
                </h6>
                {/* Measurement Fields */}
                {category === "men" && (
                  <div className="grid grid-cols-2 gap-3">
                    <TextField
                      size="small"
                      label="Shoulder"
                      name="shoulder"
                      value={customSize.shoulder}
                      onChange={handleCustomSizeChange}
                      fullWidth
                    />
                    <TextField
                      size="small"
                      label="Waist to Knee"
                      name="waistToKnee"
                      value={customSize.waistToKnee}
                      onChange={handleCustomSizeChange}
                      fullWidth
                    />
                    <TextField
                      size="small"
                      label="Chest"
                      name="chest"
                      value={customSize.chest}
                      onChange={handleCustomSizeChange}
                      fullWidth
                    />
                    <TextField
                      size="small"
                      label="Knee Line"
                      name="kneeLine"
                      value={customSize.kneeLine}
                      onChange={handleCustomSizeChange}
                      fullWidth
                    />
                    <TextField
                      size="small"
                      label="Front Shoulder to Waist"
                      name="frontShoulderToWaist"
                      value={customSize.frontShoulderToWaist}
                      onChange={handleCustomSizeChange}
                      fullWidth
                    />
                    <TextField
                      size="small"
                      label="Neck Circumference"
                      name="neckCircumference"
                      value={customSize.neckCircumference}
                      onChange={handleCustomSizeChange}
                      fullWidth
                    />
                    <TextField
                      size="small"
                      label="Waist"
                      name="waist"
                      value={customSize.waist}
                      onChange={handleCustomSizeChange}
                      fullWidth
                    />
                    <TextField
                      size="small"
                      label="Nape to Waist"
                      name="napeToWaist"
                      value={customSize.napeToWaist}
                      onChange={handleCustomSizeChange}
                      fullWidth
                    />
                    <TextField
                      size="small"
                      label="Arm Length"
                      name="armLength"
                      value={customSize.armLength}
                      onChange={handleCustomSizeChange}
                      fullWidth
                    />
                    <TextField
                      size="small"
                      label="Back Width"
                      name="backWidth"
                      value={customSize.backWidth}
                      onChange={handleCustomSizeChange}
                      fullWidth
                    />
                    <TextField
                      size="small"
                      label="Hip"
                      name="hip"
                      value={customSize.hip}
                      onChange={handleCustomSizeChange}
                      fullWidth
                    />
                    <TextField
                      size="small"
                      label="Top Arm Circumference"
                      name="topArmCircumference"
                      value={customSize.topArmCircumference}
                      onChange={handleCustomSizeChange}
                      fullWidth
                    />
                    <TextField
                      size="small"
                      label="Crotch Depth"
                      name="crotchDepth"
                      value={customSize.crotchDepth}
                      onChange={handleCustomSizeChange}
                      fullWidth
                    />
                    <TextField
                      size="small"
                      label="Waist to Floor"
                      name="waistToFloor"
                      value={customSize.waistToFloor}
                      onChange={handleCustomSizeChange}
                      fullWidth
                    />
                  </div>
                )}
                {category === "women" && (
                  <div className="grid grid-cols-2 gap-3">
                    <TextField size="small" label="Shoulder" name="shoulder" value={customSize.shoulder} onChange={handleCustomSizeChange} fullWidth />
                    <TextField size="small" label="Top Length" name="topLength" value={customSize.topLength} onChange={handleCustomSizeChange} fullWidth />
                    <TextField size="small" label="Bust" name="bust" value={customSize.bust} onChange={handleCustomSizeChange} fullWidth />
                    <TextField size="small" label="Bottom Length (with heels)" name="bottomLength" value={customSize.bottomLength} onChange={handleCustomSizeChange} fullWidth />
                    <TextField size="small" label="Under Bust" name="underBust" value={customSize.underBust} onChange={handleCustomSizeChange} fullWidth />
                    <TextField size="small" label="Kurta Length (with heels)" name="kurtaLength" value={customSize.kurtaLength} onChange={handleCustomSizeChange} fullWidth />
                    <TextField size="small" label="Armhole" name="armhole" value={customSize.armhole} onChange={handleCustomSizeChange} fullWidth />
                    <TextField size="small" label="Front Neck Depth" name="frontNeckDepth" value={customSize.frontNeckDepth} onChange={handleCustomSizeChange} fullWidth />
                    <TextField size="small" label="Sleeve Length" name="sleeveLength" value={customSize.sleeveLength} onChange={handleCustomSizeChange} fullWidth />
                    <TextField size="small" label="Back Neck Depth" name="backNeckDepth" value={customSize.backNeckDepth} onChange={handleCustomSizeChange} fullWidth />
                    <TextField size="small" label="Bicep" name="bicep" value={customSize.bicep} onChange={handleCustomSizeChange} fullWidth />
                    <TextField size="small" label="Crotch Length" name="crotchLength" value={customSize.crotchLength} onChange={handleCustomSizeChange} fullWidth />
                    <TextField size="small" label="Elbow" name="elbow" value={customSize.elbow} onChange={handleCustomSizeChange} fullWidth />
                    <TextField size="small" label="Thigh Circumference" name="thighCircumference" value={customSize.thighCircumference} onChange={handleCustomSizeChange} fullWidth />
                    <TextField size="small" label="Wrist" name="wrist" value={customSize.wrist} onChange={handleCustomSizeChange} fullWidth />
                    <TextField size="small" label="Knee Circumference" name="kneeCircumference" value={customSize.kneeCircumference} onChange={handleCustomSizeChange} fullWidth />
                    <TextField size="small" label="Waist" name="waist" value={customSize.waist} onChange={handleCustomSizeChange} fullWidth />
                    <TextField size="small" label="Calf Circumference" name="calfCircumference" value={customSize.calfCircumference} onChange={handleCustomSizeChange} fullWidth />
                    <TextField size="small" label="Lower Waist" name="lowerWaist" value={customSize.lowerWaist} onChange={handleCustomSizeChange} fullWidth />
                    <TextField size="small" label="Ankle Circumference" name="ankleCircumference" value={customSize.ankleCircumference} onChange={handleCustomSizeChange} fullWidth />
                    <TextField size="small" label="Hip" name="hip" value={customSize.hip} onChange={handleCustomSizeChange} fullWidth />
                  </div>
                )}

                {/* Contact Section */}
                <h3 className="text-md mt-5 mb-1">
                  Your Contact Details
                </h3>
                <div className="grid grid-cols-2 gap-3">
                  <TextField size="small" label="Email" name="email" type="email" value={customSize.email} onChange={handleCustomSizeChange} fullWidth />
                  <TextField size="small" label="Phone Number" name="phone" type="tel" value={customSize.phone} onChange={handleCustomSizeChange} fullWidth />
                </div>
              </div>

              {/* Right Side: Image */}
              <div className="flex items-center justify-center">
                {category === "men" &&
                  <img
                    src="https://img.perniaspopupshop.com/ppus-assets/images/CustomTailored/men-custom-tailored.jpg"
                    alt="Measurement Guide"
                    className="max-h-[600px] rounded-md shadow-sm"
                  />
                }
                {category === "women" &&
                  <img
                    src="https://img.perniaspopupshop.com/ppus-assets/images/CustomTailored/women-custom-tailored.jpg"
                    alt="Measurement Guide"
                    className="max-h-[800px] rounded-md shadow-sm"
                  />
                }
              </div>
            </div>

            {/* Checkbox */}
            <div className="mt-6">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={confirmDetails}
                    onChange={(e) => setConfirmDetails(e.target.checked)}
                  />
                }
                label="I confirm all above details are correct"
              />
            </div>
          </DialogContent>
          <DialogActions sx={{ justifyContent: "center" }}>
            <Button
              onClick={handleAddCustomSize}
              variant="contained"
              color="primary"
              disabled={!confirmDetails}
            >
              Submit Size
            </Button>
          </DialogActions>
        </Dialog>

        {/* add size dialog box form end */}
        <AuthModal handleClose={handleCloseAuthModal} open={openAuthModal} />

        {/* Full Screen Image Modal for Mobile */}
        {isFullScreenOpen && (
          <div className="fixed inset-0 z-50 bg-black bg-opacity-90 flex items-center justify-center lg:hidden">
            <div className="relative w-full h-full flex items-center justify-center p-4">
              {/* Close Button */}
              <button
                onClick={() => setIsFullScreenOpen(false)}
                className="absolute top-4 right-4 z-10 bg-white bg-opacity-20 hover:bg-opacity-30 rounded-full p-2 text-white transition-all duration-200"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>

              {/* Full Screen Image */}
              <img
                src={hoveredImage || selectedImage || mainImageUrl}
                alt="Product Full View"
                className="max-w-full max-h-full object-contain"
                onClick={() => setIsFullScreenOpen(false)}
              />

              {/* Navigation Arrows for Multiple Images */}
              {processedProduct?.images && processedProduct.images.length > 1 && (
                <>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      const currentIndex = processedProduct.images.findIndex(
                        img => img.fullUrl === (hoveredImage || selectedImage || mainImageUrl)
                      );
                      const prevIndex = currentIndex > 0 ? currentIndex - 1 : processedProduct.images.length - 1;
                      setSelectedImage(processedProduct.images[prevIndex].fullUrl);
                    }}
                    className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-20 hover:bg-opacity-30 rounded-full p-3 text-white transition-all duration-200"
                  >
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                    </svg>
                  </button>

                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      const currentIndex = processedProduct.images.findIndex(
                        img => img.fullUrl === (hoveredImage || selectedImage || mainImageUrl)
                      );
                      const nextIndex = currentIndex < processedProduct.images.length - 1 ? currentIndex + 1 : 0;
                      setSelectedImage(processedProduct.images[nextIndex].fullUrl);
                    }}
                    className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-20 hover:bg-opacity-30 rounded-full p-3 text-white transition-all duration-200"
                  >
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </button>
                </>
              )}

              {/* Image Counter */}
              {processedProduct?.images && processedProduct.images.length > 1 && (
                <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 bg-black bg-opacity-50 text-white px-3 py-1 rounded-full text-sm">
                  {processedProduct.images.findIndex(
                    img => img.fullUrl === (hoveredImage || selectedImage || mainImageUrl)
                  ) + 1} / {processedProduct.images.length}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    )
  );
}